import React from "react";
import { Chip } from "@mui/material";
import { translate, translateDate } from "../../../../../common/providers";
import { CustomIconButton, CustomTooltip, icon } from "../../../../../common/components";
import styles from "./ProjectListRow.module.css";

const ProjectListRow = ({
	isCanvas,
	isHeader,
	onAddPartner,
	onAddUser,
	onDownload,
	onChangeArchive,
	onRelaunchDocs,
	onResetElastic,
	onSelectRow,
	row,
}) => (
	<div key={row.id} className={styles.row} data-is-header={isHeader}>
		<CustomTooltip showWhenOverflow title={row.name}>
			<div className={`${styles.cell} ${styles["cell--55"]} ${styles.overflow}`}>{row.name}</div>
		</CustomTooltip>
		<CustomTooltip showWhenOverflow title={isHeader ? row.created : translateDate(row.created)}>
			<div className={`${styles.cell} ${styles["cell--15"]} ${styles.overflow}`}>
				{isHeader ? row.created : translateDate(row.created)}
			</div>
		</CustomTooltip>
		<CustomTooltip showWhenOverflow title={row.role}>
			<div className={`${styles.cell} ${styles["cell--15"]} ${styles.overflow}`}>{row.role}</div>
		</CustomTooltip>
		<div className={`${styles.cell} ${styles["cell--15"]}`}>
			{isHeader ? (
				row.currentStatus
			) : (
				<Chip
					color={(row.currentStatus === "ACTIVE" && "primary") || "default"}
					label={row.currentStatus}
					size="medium"
				/>
			)}
		</div>
		<div className={`${styles.cell} ${styles["cell--232px"]}`}>
			{isHeader ? (
				row.actions
			) : (
				<>
					{!isCanvas && (
						<>
							<CustomIconButton
								icon={icon.faInfoCircle}
								tooltip={translate("dsi.project-list.action.update-project-details")}
								variant="contained"
								onClick={() => onSelectRow(row)}
							/>
							<CustomIconButton
								icon={icon.faUserPlus}
								tooltip={translate("dsi.project-list.action.add-user")}
								variant="contained"
								onClick={() => onAddUser(row)}
							/>
							<CustomIconButton
								icon={icon.faUserCog}
								tooltip={translate("dsi.project-list.action.add-project-partner")}
								variant="contained"
								onClick={() => onAddPartner(row)}
							/>
							<CustomIconButton
								icon={icon.faDownload}
								tooltip={translate("dsi.project-list.action.download-project-docs")}
								variant="contained"
								onClick={() => onDownload(row)}
							/>
							<CustomIconButton
								icon={icon.faRefresh}
								tooltip={translate("dsi.project-list.action.relaunch")}
								variant="contained"
								onClick={() => onRelaunchDocs(row)}
							/>
							<CustomIconButton
								icon={icon.faArrowRightArrowLeft}
								iconRotation={90}
								tooltip={translate("dsi.project-list.action.reset-elastic")}
								variant="contained"
								onClick={() => onResetElastic(row.id)}
							/>
							<CustomIconButton
								icon={
									(row.currentStatus === "ACTIVE" && icon.faFileArchive) || icon.faFileArchiveRegular
								}
								tooltip={
									(row.currentStatus === "ACTIVE" && translate("common:project.status.archive")) ||
									translate("common:project.status.unarchive")
								}
								variant="contained"
								onClick={() => onChangeArchive(row)}
							/>
						</>
					)}
					{isCanvas && (
						<CustomIconButton
							icon={icon.faFile}
							tooltip="Edit document roles"
							variant="contained"
							onClick={() => onSelectRow(row)}
						/>
					)}
				</>
			)}
		</div>
	</div>
);

export default ProjectListRow;
